import { NavLink } from 'react-router-dom'
import { cn } from '@bb/ui'
import { NAV_ITEMS } from './navItems'

export function SidebarNav({ onNavigate }: { onNavigate?: () => void }) {
  return (
    <ul className="flex-1 space-y-0.5 p-2">
      {NAV_ITEMS.map(({ to, label, icon: Icon, end }) => (
        <li key={to}>
          <NavLink
            to={to}
            end={end}
            onClick={onNavigate}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-2.5 rounded-[var(--radius-control)] px-2.5 py-1.5 text-base transition-colors',
                isActive
                  ? 'bg-accent-soft font-medium text-accent'
                  : 'text-ink-muted hover:bg-sunken hover:text-ink',
              )
            }
          >
            <Icon className="size-4 shrink-0" />
            <span className="min-w-0 flex-1 truncate">{label}</span>
          </NavLink>
        </li>
      ))}
    </ul>
  )
}
